/*
 * globals.css — the single stylesheet imported from main.tsx.
 *
 * Import order matters:
 *   1. Tailwind v4 (must come first to register layers)
 *   2. HeroUI styles (consume Tailwind layers)
 *   3. The three theme files (override HeroUI's :root tokens per data-theme)
 *
 * Active theme is selected by `<html data-theme="clean|green|zixiaolabsvi">`
 * with an optional `class="dark"` modifier; index.html restores both before
 * paint to avoid FOUC.
 */

@import "tailwindcss";
@import "@heroui/styles";

@import "./theme-clean.css";
@import "./theme-green.css";
@import "./theme-zixiaolabsvi.css";

html,
body,
#root {
  height: 100%;
}

body {
  margin: 0;
  background: var(--background);
  color: var(--foreground);
  font-family: var(--font-sans, system-ui, sans-serif);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

/* Small typography defaults for raw markdown rendering. */
.wuling-prose h1 { font-size: 1.75rem; font-weight: 700; margin: 1rem 0 0.5rem; }
.wuling-prose h2 { font-size: 1.5rem;  font-weight: 700; margin: 1rem 0 0.5rem; }
.wuling-prose h3 { font-size: 1.25rem; font-weight: 600; margin: 0.75rem 0 0.5rem; }
.wuling-prose p  { margin: 0.5rem 0; line-height: 1.65; }
.wuling-prose code {
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
  background: var(--surface-secondary);
  padding: 0.1rem 0.35rem;
  border-radius: 0.25rem;
}
.wuling-prose pre {
  background: var(--surface-secondary);
  padding: 0.75rem;
  border-radius: 0.5rem;
  overflow-x: auto;
}
.wuling-prose pre code { background: transparent; padding: 0; }
.wuling-prose a { color: var(--accent); text-decoration: underline; }
.wuling-prose ul, .wuling-prose ol { padding-left: 1.5rem; margin: 0.5rem 0; }
.wuling-prose blockquote {
  border-left: 3px solid var(--border);
  padding-left: 0.75rem;
  color: var(--muted);
  margin: 0.5rem 0;
}
.wuling-prose table { border-collapse: collapse; }
.wuling-prose table td, .wuling-prose table th {
  border: 1px solid var(--border);
  padding: 0.4rem 0.6rem;
}
